// SocialPost rows legitimately have an `error` string describing a failed
// channel. Only the API's explicit `{ error: true }` envelope (or an HTTP error)
// is a failed request; treating any truthy `error` as transport failure makes the
// failed-post reviewer and its recovery actions unreachable.
export const isSocialErrorResponse = (status, payload) =>
    Number(status) >= 400 || Boolean(payload && payload.error === true);
